import { useTranslation } from 'react-i18next'

import { emojis } from './constants'

export const useCustomEmoji = () => {
  const { t } = useTranslation()

  return [
    {
      id: 'social_networks',
      name: t('emoji_picker.categories.social_networks'),
      emojis: emojis.map((emoji) => ({
        id: emoji.id,
        name: emoji.name,
        keywords: emoji.keywords,
        skins: [{ src: emoji.icon }]
      }))
    }
  ]
}
